/* global I18n */
import './styles.scss'

import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'

import Twicpics from 'lib/tags/twicpics'
import railsContext from 'lib/selectors/rails-context'

import { uploadIcon, cameraIcon, profileIcon, closeIcon } from '../_assets/icons-map'
import { ACCEPTED_EXTENSIONS } from '../constants'

const DesktopProfilePhoto = React.forwardRef(
  (
    {
      avatar,
      closeModal,
      fileValue,
      handleChangeUploadImage,
      handleInputWebcamCapture,
      handleUploadImage,
      handleWebcam,
      withIconsUi
    },
    ref
  ) => {
    const { dpr } = useSelector(railsContext)
    const { uploadImageInputRef, webcamInputRef } = ref

    return (
      <>
        <div className='desktop-profile-photo'>
          {avatar && <img src={closeIcon} alt='close-icon' className='close-icon' onClick={closeModal} />}
          <p className='title'>{I18n.t('profiles.edit.avatar')}</p>
          <p className='subtitle'>{I18n.t('popups.profile_photo.subtitle')}</p>
          <div className='sections-container'>
            <div className='tips-section'>
              <div className='tips-container'>
                <p className='tips-name'>{I18n.t('popups.profile_photo.tips_name')}</p>
                <ul className='tips'>
                  <li>{I18n.t('popups.profile_photo.tip_1')}</li>
                  <li>{I18n.t('popups.profile_photo.tip_2')}</li>
                  <li>{I18n.t('popups.profile_photo.tip_3')}</li>
                  <li>{I18n.t('popups.profile_photo.tip_4')}</li>
                  <li>{I18n.t('popups.profile_photo.tip_5')}</li>
                </ul>
              </div>
              <div className='other-tips-container'>
                <p className='other-tips'>{I18n.t('popups.profile_photo.other_tips')}</p>
                <div className='faces'>
                  <div className='face valid valid-1'></div>
                  <div className='face valid valid-2'></div>
                  <div className='face valid valid-3'></div>
                  <div className='face valid valid-4'></div>
                  <div className='face invalid invalid-1'></div>
                  <div className='face invalid invalid-2'></div>
                  <div className='face invalid invalid-3'></div>
                  <div className='face invalid invalid-4'></div>
                </div>
              </div>
            </div>
            <div className='picture-section'>
              <div className='picture-container'>
                <div className='profile-container'>
                  {avatar ? (
                    <Twicpics
                      src={avatar}
                      alt='Avatar'
                      dpr={dpr}
                      passThrough={true}
                      width={150}
                      height={150}
                      className='avatar-image'
                    />
                  ) : (
                    <img src={profileIcon} alt='profile-icon' className='profile-icon' />
                  )}
                </div>
                <div className='profile-picture-requirements-container'>
                  <ul className='profile-picture-requirements'>
                    <li className='requirement'>{I18n.t('popups.profile_photo.requirement_1')}</li>
                    <li className='requirement'>{I18n.t('popups.profile_photo.requirement_2')}</li>
                    <li className='requirement'>{I18n.t('popups.profile_photo.requirement_3')}</li>
                  </ul>
                </div>
                <div className='buttons-section'>
                  <div className='take-a-picture-container' onClick={handleWebcam}>
                    <div className='camera-icon-container'>
                      <img src={cameraIcon} alt='camera-icon' className='camera-icon' />
                    </div>
                    <p className='camera-text'>{I18n.t('bookings.contact_details.take_picture')}</p>
                    {withIconsUi && (
                      <input
                        ref={webcamInputRef}
                        type='file'
                        id='webcam-input'
                        className='webcam-input'
                        capture='user'
                        accept='image/jpeg, image/jpg, image/gif, image/png'
                        onChange={handleInputWebcamCapture}
                      />
                    )}
                  </div>
                  <div className='upload-image-container' onClick={handleUploadImage}>
                    <div className='upload-icon-container'>
                      <img src={uploadIcon} alt='upload-icon' className='upload-icon' />
                    </div>
                    <p className='upload-text'>{I18n.t('activerecord.attributes.user.avatar_format_custom')}</p>
                    <input
                      ref={uploadImageInputRef}
                      type='file'
                      className='upload-form'
                      accept={ACCEPTED_EXTENSIONS.join(',')}
                      onChange={handleChangeUploadImage}
                      value={fileValue}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
)

DesktopProfilePhoto.displayName = 'DesktopProfilePhoto'

DesktopProfilePhoto.propTypes = {
  handleWebcam: PropTypes.func,
  handleUploadImage: PropTypes.func,
  handleChangeUploadImage: PropTypes.func,
  closeModal: PropTypes.func,
  handleInputWebcamCapture: PropTypes.func,
  avatar: PropTypes.string,
  fileValue: PropTypes.string,
  withIconsUi: PropTypes.bool
}

export default DesktopProfilePhoto
